import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const followUpFilter: ILayoutFilter[] = [
  {
    id: 'empresaIds',
    label: 'Empresa',
    type: 'checkbox',
    isDisabled: true
  },
  {
    id: 'empresaSelectIds',
    label: '',
    filterId: 'companies',
    type: 'select',
    isMulti: true,
    value: true
  },

  {
    id: 'categoriasIds',
    label: 'Categoria Compacta',
    type: 'checkbox'
  },
  {
    id: 'categoriasSelectIds',
    label: '',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriaIds',
    label: 'Categoria',
    agroupDefault: true,
    value: true,
    type: 'checkbox'
  },
  {
    id: 'categoriaSelectIds',
    label: '',
    filterId: 'categories',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'gerenteCategoriaIds',
  //   label: 'Gerente de Categoria',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'gerenteCategoriaSelectIds',
  //   label: '',
  //   filterId: 'categoryManagers',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'gerenteProdutoIds',
    label: 'Gerente de Produto',
    type: 'checkbox'
  },
  {
    id: 'gerenteProdutoSelectIds',
    label: '',
    filterId: 'productManagers',
    type: 'select',
    isMulti: true
  },

  {
    id: 'mundoIds',
    label: 'Mundo',
    type: 'checkbox'
  },
  // {
  //   id: 'mundoSelectIds',
  //   label: '',
  //   filterId: 'worlds',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'productsIds',
    label: 'Produto',
    type: 'checkbox'
  },
  {
    id: 'productsSelectIds',
    label: '',
    type: 'select-api-post',
    apiUrl: '/v1/Produto',
    isMulti: true
  }
]
